const rangeCheck = require('range_check'),
    BLACKLISTED_IPS = require('../constants/blacklisted-enode-ips');

const showIP = enode => {
    const
        startIndex = enode.lastIndexOf('@') + 1,
        endIndex = enode.lastIndexOf(':');
    return enode.substring(startIndex, endIndex);
};

const withinRange = (enode, range) => {
    return rangeCheck.inRange(showIP(enode), range);
};

const validIP = enode => {
    return !BLACKLISTED_IPS.find(range => withinRange(enode, range));
};

module.exports = {
    showIP,
    validIP,
    withinRange,
};
